<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../helpers/utilities';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Stores;
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';

	export let device: Device, setting: string;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	const localUnit = settings.sensors.temperature_unit;

	let value = settings[`${setting}_offset`];
	let waitForResponse = false;
	let unit = localUnit;

	let min = device.type === 'SHMOS-02' ? -10 : -50;
	let max = device.type === 'SHMOS-02' ? 10 : 50;

	const save = async () => {
		waitForResponse = true;

		let res: SettingRequest;
		if (device.type === 'SHDW-2') {
			res = await postReq(
				`/device/${device.category}/settings/set_command`,
				{
					id,
					set: `${setting}_offset`,
					command: value,
				},
				10000,
			);
		} else {
			let data = {
				id,
				[`${setting === 'temperature' ? 'tmp' : 'hum'}`]: value,
			};

			if (device.type === 'SHHT-1') {
				data[`${setting === 'temperature' ? 'hum' : 'tmp'}`] =
					settings[`${setting === 'temperature' ? 'humidity_offset' : 'temperature_offset'}`];
			}

			res = await postReq(`/device/${device.category}/settings/set_offset`, data, 10000);
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);

	const handleChange = (e) => {
		value = e.target.value;
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{setting === 'temperature'
		? $format('text_sensor_settings_temperature', {
				values: { unit: unit },
				default: `Offset in °${unit} to be applied to the measured temperature.`,
			})
		: $format('text_sensor_settings_humidity', {
				default: `Humidity offset in %. Value is applied to measured humidity.`,
			})}</Text
>
<Input
	{...getNumberInputConfig()}
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	on:input={(e) => handleChange(e)}
	on:enter={save}
	{value}
	info={inputData.info}
	error={inputData.error}
	step={1}
	id="input-131sg6i"
	aria-label={$format('offset_wrapper_input', {
		default: 'Offset value',
	})}
/>

<Button size="m" width="full" loading={waitForResponse} disabled={inputData.error} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
